'use client';
import { jsx } from 'react/jsx-runtime';
import t from 'prop-types';
import { useState } from 'react';
import t$1 from 'tiny-warning';
import { useComponentStylesLoaded } from '../../hooks/use-component-styles-loaded.js';
import { CollapsibleContext } from './collapsible.context.js';
import { useAccordionContext } from '../accordion/accordion.context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';
import { RenderComp } from '../core/render-comp.component.js';
import { useControllableValue } from '../../hooks/use-controllable-value.js';

function _define_property(e, o, r) {
    return o in e ? Object.defineProperty(e, o, {
        value: r,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[o] = r, e;
}
function _object_spread(e) {
    for(var o = 1; o < arguments.length; o++){
        var r = null != arguments[o] ? arguments[o] : {}, t = Object.keys(r);
        "function" == typeof Object.getOwnPropertySymbols && (t = t.concat(Object.getOwnPropertySymbols(r).filter(function(e) {
            return Object.getOwnPropertyDescriptor(r, e).enumerable;
        }))), t.forEach(function(o) {
            _define_property(e, o, r[o]);
        });
    }
    return e;
}
function ownKeys(e, o) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var t = Object.getOwnPropertySymbols(e);
        r.push.apply(r, t);
    }
    return r;
}
function _object_spread_props(e, o) {
    return o = null != o ? o : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(o)) : ownKeys(Object(o)).forEach(function(r) {
        Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(o, r));
    }), e;
}
let d = {
    expanded: t.bool,
    onRequestExpandedChange: t.func,
    fullBleed: t.bool,
    defaultExpanded: t.bool,
    collapsibleId: t.string,
    disabled: t.bool,
    headingLevel: t.oneOf([
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6'
    ])
}, b = Object.keys(d), useCollapsibleContextProps = (e)=>{
    let { expanded: o, onRequestExpandedChange: l, defaultExpanded: a = false, collapsibleId: i, disabled: s = false, headingLevel: c } = e, [d, b] = useState(), u = useAccordionContext(), f = void 0 !== u;
    t$1(!f || void 0 === o && void 0 === l, 'When a Collapsible is used inside of an Accordion, you must provide the expanded-state to the Accordion component rather than directly to the Collapsible'), t$1(!(f && void 0 === i), 'When a Collapsible is used inside of an Accordion, the Collapsible must have a `collapsibleId`');
    let [m, h] = useControllableValue({
        value: o,
        onChange: l || void 0,
        defaultValue: a,
        defaultOnChange: (e, o)=>e(o)
    }), y = !!m, O = h;
    return f && (y = !!(null == u ? void 0 : u.expandedCollapsibleMap[i]), O = (e)=>{
        null == u || u.requestExpandedChange(i, e);
    }), {
        expanded: y,
        onRequestExpandedChange: O,
        contentId: d,
        setContentId: b,
        disabled: s,
        purpose: null == u ? void 0 : u.purpose,
        headingLevel: c
    };
}, u = 'Collapsible';
const Collapsible = renderWithRef(u, d, (o, r)=>{
    useComponentStylesLoaded(u, SWAN_STYLE_KEY_MAP.accordion);
    let { disabled: t = false, fullBleed: n = false } = o, a = new Set([
        'swan-vanilla-ignore',
        'swan-collapsible'
    ]);
    t && a.add('swan-collapsible-disabled'), n && a.add('swan-collapsible-full-bleed');
    let p = useCollapsibleContextProps(o), d = _object_spread_props(_object_spread({}, o), {
        'aria-disabled': !!o.disabled,
        as: o.as || o.component || ((null == p ? void 0 : p.purpose) === 'list' ? 'li' : 'div')
    });
    return jsx(CollapsibleContext.Provider, {
        value: _object_spread({}, p),
        children: jsx(RenderComp, {
            root: "div",
            forwardedRef: r,
            classNames: a,
            propKeysToRemove: b,
            props: d,
            children: o.children
        })
    });
});

export { Collapsible };
